module.exports = __webpack_public_path__ + "img/arms.1bc7d2ea.jpg";